export default __webpack_public_path__ + "static/media/020-wool hat.184b4d56.svg";